import React from "react";
import { ReminderCollector } from "api";
import { CustomMaterialTable } from "components";
import { COLUMNS } from "./columns";

export const SendReminderCollectorsTable = ({
  collectors,
}: {
  collectors: ReminderCollector[];
}) => (
  <CustomMaterialTable
    data={collectors}
    columns={COLUMNS}
    layoutMode="grid"
    enableTopToolbar={false}
    enableColumnActions={false}
    enableSorting={false}
    enableColumnFilters={false}
    enablePagination={false}
    enableRowVirtualization={false}
    headCellSx={{ fontSize: "13px", color: "inherit" }}
    headRowSx={{ backgroundColor: "grey.100", height: "auto" }}
    bodyCellSx={{ fontSize: "13px", py: 1.25 }}
    containerSx={{ borderColor: "grey.200", borderRadius: "6px" }}
  />
);
